/* eslint-disable object-curly-newline */
import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import { PINK, PURPLE_TEXT, WHITE, PURPLE_NEON } from '../../../constants/colors';

export default {

  mobileLayout: css`
    ${media.sm`
      display: none;
    `};
  `,
  desktopLayout: css`
  display: none;
  ${media.sm`
    display: flex;
  `};
`,
  lists: css`
    margin-left:0;
    padding-left:0;
    list-style-type:none;
  `,
  tiplink: css`
  &:hover{color: ${PINK}; text-decoration:underline;}
  text-decoration:underline;
  color: ${PINK};
`,
  listitem: ({ highlight }) => css`
    font-size: ${rem('12px')};
    line-height: ${rem('20px')};
    color: ${WHITE};
    ${highlight && css`
    color: ${PINK};
    `}
  `,
  textnote: css`
    margin-bottom: 35px;
    margin-top: 10px;
    font-size: ${rem('10px')};
    color: ${PURPLE_NEON};
  `,
  title: css`
    margin-bottom: 25px;
    margin-top: 50px;
    font-size: ${rem('20px')};
    line-height: ${rem('26px')};
    color: ${PINK};
    ${media.sm`
      margin-top: 60px;
    `};
  `,
  subtitle: css`
    margin-bottom: 20px;
    font-size: ${rem('16px')};
    line-height: ${rem('22px')};
    color: ${PURPLE_NEON};
  `,
  description: css`
    font-size: ${rem('16px')};
    line-height: ${rem('26px')};
    color: ${WHITE};
    ${media.sm`
      font-size: ${rem('14px')};
      line-height: ${rem('26px')};
    `};
  `,
  tips: css`
    margin-bottom: 35px;
    font-size: ${rem('16px')};
    line-height: ${rem('26px')};
    color: ${WHITE};
    ${media.sm`
      font-size: ${rem('14px')};
      line-height: ${rem('22px')};
    `};
  `,
  wrapper: css`
    position: relative;
    width: 100%;
    overflow: hidden;
  `,
  diagonalWrapper: css`
    position: relative;
    overflow: hidden;
    width: 100%;
    top: 0;
    background-color: ${PURPLE_TEXT};
    height: auto;
    margin-bottom:20px;
    padding-bottom: 30px;
    ${media.sm`
      margin-bottom:0px;
      padding-bottom: 0px;
    `};
  `,
  triangle: css`
    display:none;
    margin-bottom:30px;
    ${media.sm`
      display:block;
    `};
    position: relative;
    width: 100%;
    height: 233px;
    border-style: solid;
    border-width: 233px 100vw 0 0;
    border-color: ${PURPLE_TEXT} transparent transparent transparent;
  `
};
